import { render, staticRenderFns } from "./evidencia-inspeccion-editar.vue?vue&type=template&id=60cef4f6&"
import script from "./evidencia-inspeccion-editar.vue?vue&type=script&lang=js&"
export * from "./evidencia-inspeccion-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports